/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react"
import { POTENCIA_MINIMA_VERTICAL, PROPOSTA_OPTIONS } from "src/components/projetos/constants"
import { Option, Projeto, PropostaValueType } from "src/components/projetos/types"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"

interface SelectTipoPropostaProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
}

function SelectTipoProposta({ formState, setFormState }: SelectTipoPropostaProps) {
  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[formState?.modulosList]);

  const potenciaVertical = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_VERTICAL;
  },[potenciaTotal]);

  const tipoPropostaOptions = useMemo(()=>{
    if (!formState.recebe_servico) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if (!formState.revenda) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if (!formState?.revenda?.segmentos_servico?.includes(formState?.segmento?.includes("on") ? "on" : "off")) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if (potenciaVertical) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if ((formState.tipo === 'personalizado' || formState.tipo === 'kit') && formState.tipo_faturamento !== 'cliente') return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    return PROPOSTA_OPTIONS
  },[formState.recebe_servico, formState.revenda, formState.tipo, formState.tipo_faturamento, potenciaVertical]);

  const tipoProposta = potenciaVertical ? PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') : formState.tipo_proposta;
  
  return (
    <InputComboBoxList
      id={`select-proposta`}
      key={`select-proposta`}
      label={"* Tipo de proposta"}
      textField="text"
      valueField="value"
      disabled={tipoPropostaOptions.length <= 1}
      options={tipoPropostaOptions}
      value={tipoProposta}
      autoComplete
      renderOptions={(option: any) => {
        return `${option.text}`
      }}
      renderOptionsLabel={(option: any) => {
        return `${option.text}`
      }}
      onChange={(value: Option<PropostaValueType> | null) => {
        const state = {...formState}
        
        state.tipo_proposta = value
        
        if (value?.value === 'gerador-sem-instalacao') {
          state.valor_servico = 0;
          state.tempo_garantia_servico = 0
          state.valor_margem_produtos = 0;
        }
        
        setFormState(state)
      }}
    />
  )
}

export { SelectTipoProposta }